import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchEmotions = (params = {}) => {
    return axios.get('/api/v1/emotions/', { params });
};
